import { createSelector } from 'reselect';

import { determinatePriorityChannel, getActivatedChannels } from '../utils';

/** @return {import("../reducers").CampaignReducer} */
const getState = state => state.campaigns;
export const getRoot = state => state;
export const getProps = (_, props) => props;

const getDataState = createSelector(getState, state => state.data);

const getDataEntities = createSelector(getDataState, state => state.entities);

export const getUIState = createSelector(getState, state => state.ui);

const getStatisticsState = createSelector(getState, state => state.statistics);

export const getCampaignById = createSelector(
  getDataEntities,
  getProps,
  (entities, campaignId) => entities[campaignId]
);

export const getCampaignsByIds = createSelector(getDataEntities, getProps, (entities, ids = []) =>
  ids.reduce((acc, campaignId) => {
    const entity = entities[campaignId];
    if (entity) {
      return [...acc, entity];
    }
    return acc;
  }, []));

export const getCampaignsChannelById = createSelector(getCampaignById, getActivatedChannels);

export const getPriorityChannel = createSelector(getCampaignById, determinatePriorityChannel);

export const getStatisticsById = createSelector(
  getStatisticsState,
  getProps,
  (statistics, campaignId) => statistics[campaignId]
);
